import React,{useEffect,useState} from 'react';
import bgHero from "../Assets/images/herobg.png"
import heroMobile from "../Assets/images/DDDD.png"
import android from "../Assets/images/android.png"
import apple from "../Assets/images/apple.png"
import { Link } from 'react-router-dom';
const Hero = () => {
    const [windowWidth, setWindowWidth] = useState(0);



    let resizeWindow = () => {
        setWindowWidth(window.screen.width);
    };

    useEffect(() => {
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    }, []);

    return(
        <div
            style={{
                backgroundImage: `url(${bgHero})`,
                backgroundSize: windowWidth < 500 ? '45%' : '15%',  // Ensures the image covers the entire div
                backgroundPosition: 'top right', // Centers the image
                backgroundRepeat: 'no-repeat', // Prevents tiling

            }}
            className="w-full flex ">
            <div className='flex flex-col lg:flex-row  lg:items-end justify-center lg:mx-auto lg:w-maxWidth w-full pt-24 pb-24  lg:pt-24 gap-10 lg:gap-0'>
                <div className="w-full lg:p-0  p-4  lg:w-2/4 flex flex-col gap-5 ">
                    <h2 className="font-roboto text-2xl lg:text-4xl font-light text-primary ">PayPro for <b className="font-bold">Business</b></h2>
                    <p className=" font-roboto text-secondary text-lg">
                        PayPro Business fulfills all your online payment acceptance
                        requirements by providing a world of payment options in the palm
                        of your hand. PayPro helps you expand your customer outreach,
                        keep track of all your online sales, increase business performance,
                        and offer your customers an empowering experience with
                        a lasting impression.
                    </p>
                    <div className='w-full flex gap-4 items-center justify-center lg:justify-start'>
                        <Link className=' w-2/5 md:w-1/3  lg:w-2/5' to="https://play.google.com/store/apps/details?id=com.paypro.paypromerchantapp&pcampaignid=web_share&pli=1">
                        <img  src={android} alt={android} />
                        </Link>
                        <Link className=' w-2/5 md:w-1/3   lg:w-2/5'  to="https://apps.apple.com/pk/app/paypro-business/id1641573540">
                        <img src={apple} alt={apple} />
                        </Link>
                    </div>
                </div>
                <div className="w-full  lg:w-2/4 flex items-center  justify-center ">
                    <img className=" w-2/4  md:w-2/6 lg:w-2/5 " src={heroMobile} alt={heroMobile} />
                </div>
            </div>
        </div>
    );
}

export  default Hero